import { render, staticRenderFns } from "./DashboardKurir.vue?vue&type=template&id=3b91f5fa"
import script from "./DashboardKurir.vue?vue&type=script&lang=js"
export * from "./DashboardKurir.vue?vue&type=script&lang=js"
import style0 from "./DashboardKurir.vue?vue&type=style&index=0&id=3b91f5fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports